import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import {
    Button,
    Grid2,
    FormGroup,
    FormControlLabel,
    Checkbox,
    TextField,
    Typography,
} from "@mui/material";
import { Savenewsletter } from "../../actions/front_actions";
import CustomReactValidator from "../CustomReactValidator";

// Optionally, use the styled utility for custom styles
const FullWidthPaper = styled(Paper)({
    width: "100%", // Ensures the Paper spans the full width
    padding: "16px", // Optional: Add padding for better spacing
});

class Newsletter extends Component {
    constructor(props) {
        super(props);

        this.validator = new CustomReactValidator({
            messages: {
                email: this.props.t("email_validation"),
            },
        });

        this.state = {
            newsletter: "",
            email_address: "",
            thanks_msg: "",
            error_msg: "",
        };
    }

    handleEmailValChange = (event) => {
        this.setState({ email_address: event.target.value });
    };

    handleCheckbox = (event) => {
        const isChecked = event.target.checked;
        // Set value to 1 if checked, otherwise 0
        const value = isChecked ? 1 : 0;
        this.setState({ newsletter: value });
    };

    submitForm = () => {
        if (this.validator.allValid()) {
            this.props
                .Savenewsletter(
                    this.props.SITE_URL,
                    this.state.newsletter,
                    this.state.email_address,
                    this.props.short.user_id_profile
                )
                .then((val) => {
                    this.setState({
                        newsletter: "",
                        email_address: "",
                        thanks_msg: val.subscribed === true,
                        error_msg: val.subscribed === false,
                    });
                });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    render() {
        const { t, i18n } = this.props;
        const {
            onlyloggedinuser,
            vote_grab_news_email,
            vote_tracking_method,
            vote_grab_email_address,
        } = this.props.settings.contest;
        let email_field = this.props.email_field !== undefined ? 1 : 0;
        let check_logged =
            this.props.short.user_logged !== undefined &&
            this.props.short.user_logged !== false
                ? 1
                : 0;
        let check_newsletter = this.props.short.check_newsletter;

        return (
            <React.Fragment>
                {vote_grab_news_email == "on" &&
                    check_newsletter == 0 &&
                    email_field == 0 &&
                    (check_logged == 1 ||
                        (vote_grab_email_address == "off" &&
                            (vote_tracking_method == "ip_traced" ||
                                vote_tracking_method == "cookie_traced" ||
                                vote_tracking_method == "user_traced"))) && (
                        <FullWidthPaper elevation={3}>
                            <Grid2
                                container
                                direction="row"
                                spacing={3}
                                sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                {check_logged == 0 && (
                                    <Grid2 size={6}>
                                        <TextField
                                            className="wpvc_text_field"
                                            type="text"
                                            name="email_address"
                                            value={this.state.email_address}
                                            label={t("enter_email_address")}
                                            onChange={(event) =>
                                                this.handleEmailValChange(event)
                                            }
                                            fullWidth
                                        />
                                        {this.validator.message(
                                            t("voter_email_required"),
                                            this.state.email_address,
                                            "required|email"
                                        )}
                                    </Grid2>
                                )}
                                {/* Full-width Checkbox */}
                                <Grid2 size={4}>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="newsletter"
                                                    value={true}
                                                    checked={
                                                        this.state
                                                            .newsletter === 1
                                                    }
                                                    onChange={(event) =>
                                                        this.handleCheckbox(
                                                            event
                                                        )
                                                    }
                                                />
                                            }
                                            label={t("check_email_newsletter")}
                                        />
                                    </FormGroup>
                                    {this.validator.message(
                                        t("enable_checkbox"),
                                        this.state.newsletter,
                                        "required"
                                    )}
                                </Grid2>
                                {/* Full-width Subscribe Button */}
                                <Grid2 size={2}>
                                    <Button
                                        variant="contained"
                                        className="wpvc_login_btns"
                                        color="secondary"
                                        onClick={this.submitForm}
                                    >
                                        {t("subscribe_news")}
                                    </Button>
                                </Grid2>
                            </Grid2>
                            {this.state.thanks_msg == 1 && (
                                <Typography
                                    variant="body2"
                                    align="center"
                                    style={{ color: "green" }}
                                    className="wpvc_span_to_p"
                                >
                                    {t("newsletter_thanks")}
                                </Typography>
                            )}
                            {this.state.error_msg == 1 && (
                                <Typography
                                    variant="body2"
                                    align="center"
                                    style={{ color: "green" }}
                                    className="wpvc_span_to_p"
                                >
                                    {t("newsletter_error")}
                                </Typography>
                            )}
                        </FullWidthPaper>
                    )}
                {vote_grab_news_email == "on" && email_field == 1 && (
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="vote_newsletter"
                                    value={true}
                                    onChange={(event) =>
                                        this.props.handleVoterDetails(event)
                                    }
                                />
                            }
                            label={t("check_email_newsletter")}
                        />
                    </FormGroup>
                )}
            </React.Fragment>
        );
    }
}
export default connect("", { Savenewsletter })(
    withTranslation("translations")(Newsletter)
);
